import { combineReducers } from "redux";
import LoginReducer from "./LoginReducer";
import NewsReducer from "./NewsReducer";

const rootReducer = combineReducers({
  auth: LoginReducer,
  news: NewsReducer,
});

export default rootReducer;
